$('#hg-sort .sort-item').on('click', function(event) {
    event.preventDefault();
    if(!$(this).hasClass('active')){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');

        const sortValue = $(this).attr('data-val');
        $('#SortBy-mobile').val(sortValue);

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('sort_by', sortValue);

        fetch(`${newUrl.toString()}?_pjax=true`)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // Знаходимо і замінюємо вміст сітки товарів
                const newProductGrid = doc.querySelector('.product-grid-container');
                const currentProductGrid = document.querySelector('.product-grid-container');
                if (newProductGrid && currentProductGrid) {
                    currentProductGrid.innerHTML = newProductGrid.innerHTML;
                }
                window.history.pushState({}, '', newUrl.toString());
                location.reload();
            })
            .catch(error => {
                console.error('Помилка асинхронного сортування:', error);
            });
    }
});
if ($(window).width() < 1023) {

$('#FacetFiltersFormMobile summary').unbind('click').click(function() {
  if(!$(this).hasClass('active')){
    $(this).addClass('active');
    $(this).next('div').slideDown();
  }else{
    $(this).removeClass('active');
    $(this).next('div').slideUp();
  }
});
}
          $('.hg-ll-img-st').each(function() {
            if ($(window).width() > 1040 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-m-i');
            }
            if ($(this).is('[style="background-image"]')){ }else {
            $(this).css('background-image','url('+$lod_i+')');
            }
          });
      var doAnimations = function() {
      var offset = $(window).scrollTop() + $(window).height(),
          $animatables = $('.animatable');
      if ($animatables.length == 0) {
        $(window).off('scroll', doAnimations);
      }
      
      $animatables.each(function(i) {
         var $animatable = $(this);
           if ($(window).width() < 960) {
            var $scrollstep = 150;
           }else{
            var $scrollstep = 200;
           };
        if (($animatable.offset().top  + $scrollstep) < offset) {
          $animatable.removeClass('animatable').addClass('animated');
        }
      });
    };
    $(window).on('scroll', doAnimations);

$('.prods-sl-n').flickity({ 
      cellAlign: 'left',
      pageDots : false,
      bgLazyLoad: 1,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      lazyLoad: true,
    });
$('.prods-sl-n').flickity().on( 'change.flickity', function( event, index ) {
      $slide_p = index + 1;
      $(this).parents('.has-nav').find('.cur-c').html( $slide_p );
    $('.hg-slide:nth-child('+$slide_p+')').find('.hg-video').trigger('play');
    $('.hg-slide:nth-child('+$slide_p+')').nextAll().find('.hg-video').trigger('pause');
      $('.hg-slide:nth-child('+$slide_p+')').prevAll().find('.hg-video').trigger('pause');
 });

 setTimeout(function(){ 
  $('body').addClass('page-load');  
  $(window).trigger('scroll');
 }, 100 );
  

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }



if ($(window).width() < 1023) {

$('#FacetFiltersFormMobile summary').unbind('click').click(function() {
  if(!$(this).hasClass('active')){
    $(this).addClass('active');
    $(this).next('div').slideDown();
  }else{
    $(this).removeClass('active');
    $(this).next('div').slideUp();
  }
});
}
          $('.hg-ll-img-st').each(function() {
            if ($(window).width() > 1040 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-m-i');
            }
            if ($(this).is('[style="background-image"]')){ }else {
            $(this).css('background-image','url('+$lod_i+')');
            }
          });
      var doAnimations = function() {
      var offset = $(window).scrollTop() + $(window).height(),
          $animatables = $('.animatable');
      if ($animatables.length == 0) {
        $(window).off('scroll', doAnimations);
      }
      
      $animatables.each(function(i) {
         var $animatable = $(this);
           if ($(window).width() < 960) {
            var $scrollstep = 150;
           }else{
            var $scrollstep = 200;
           };
        if (($animatable.offset().top  + $scrollstep) < offset) {
          $animatable.removeClass('animatable').addClass('animated');
        }
      });
    };
    $(window).on('scroll', doAnimations);

 setTimeout(function(){ 
  $('body').addClass('page-load');  
  $(window).trigger('scroll');
 }, 100 );
  



  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  

if ($(window).width() < 1023) {

$('#FacetFiltersFormMobile summary').unbind('click').click(function() {
  if(!$(this).hasClass('active')){
    $(this).addClass('active');
    $(this).next('div').slideDown();
  }else{
    $(this).removeClass('active');
    $(this).next('div').slideUp();
  }
});
}
          $('.hg-ll-img-st').each(function() {
            if ($(window).width() > 1040 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-m-i');
            }
            if ($(this).is('[style="background-image"]')){ }else {
            $(this).css('background-image','url('+$lod_i+')');
            }
          });
      var doAnimations = function() {
      var offset = $(window).scrollTop() + $(window).height(),
          $animatables = $('.animatable');
      if ($animatables.length == 0) {
        $(window).off('scroll', doAnimations);
      }
      
      $animatables.each(function(i) {
         var $animatable = $(this);
           if ($(window).width() < 960) {
            var $scrollstep = 150;
           }else{
            var $scrollstep = 200;
           };
        if (($animatable.offset().top  + $scrollstep) < offset) {
          $animatable.removeClass('animatable').addClass('animated');
        }
      });
    };
    $(window).on('scroll', doAnimations);
$('.prods-sl-n').flickity({ 
      cellAlign: 'left',
      pageDots : false,
      bgLazyLoad: 1,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      lazyLoad: true,
    });
$('.prods-sl-n').flickity().on( 'change.flickity', function( event, index ) {
      $slide_p = index + 1;
      $(this).parents('.has-nav').find('.cur-c').html( $slide_p );
    $('.hg-slide:nth-child('+$slide_p+')').find('.hg-video').trigger('play');
    $('.hg-slide:nth-child('+$slide_p+')').nextAll().find('.hg-video').trigger('pause');
      $('.hg-slide:nth-child('+$slide_p+')').prevAll().find('.hg-video').trigger('pause');
 });
 setTimeout(function(){ 
  $('body').addClass('page-load');  
  $(window).trigger('scroll');
 }, 100 );
  


$('#hg-sort .sort-item').on('click',  function() {
  if(!$(this).hasClass('active')){
    $(this).addClass('active');
    $(this).nextAll().removeClass('active');
    $(this).prevAll().removeClass('active');
    $('#SortBy-mobile').find('option[value="'+$(this).attr('data-val')+'"]').trigger('click');
    $('#SortBy-mobile').find('option[value="'+$(this).attr('data-val')+'"]').prevAll().removeAttr('selected');
    $('#SortBy-mobile').find('option[value="'+$(this).attr('data-val')+'"]').nextAll().removeAttr('selected');
    $('#SortBy-mobile').find('option[value="'+$(this).attr('data-val')+'"]').attr('selected', 'selected');

    $('#SortBy-mobile').val($(this).attr('data-val'));
    $('#SortBy-mobile').trigger('change');
    $('#FacetFiltersForm').trigger('submit');
  }else{

  }
});



      var doAnimations = function() {
      var offset = $(window).scrollTop() + $(window).height(),
          $animatables = $('.animatable');
      if ($animatables.length == 0) {
        $(window).off('scroll', doAnimations);
      }
      
      $animatables.each(function(i) {
         var $animatable = $(this);
           if ($(window).width() < 960) {
            var $scrollstep = 150;
           }else{
            var $scrollstep = 200;
           };
        if (($animatable.offset().top  + $scrollstep) < offset) {
          $animatable.removeClass('animatable').addClass('animated');
        }
      });
    };
    $(window).on('scroll', doAnimations);
$('.prods-sl-n').flickity({ 
      cellAlign: 'left',
      pageDots : false,
      bgLazyLoad: 1,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      lazyLoad: true,
    });
$('.prods-sl-n').flickity().on( 'change.flickity', function( event, index ) {
      $slide_p = index + 1;
      $(this).parents('.has-nav').find('.cur-c').html( $slide_p );
    $('.hg-slide:nth-child('+$slide_p+')').find('.hg-video').trigger('play');
    $('.hg-slide:nth-child('+$slide_p+')').nextAll().find('.hg-video').trigger('pause');
      $('.hg-slide:nth-child('+$slide_p+')').prevAll().find('.hg-video').trigger('pause');
 });
 setTimeout(function(){ 
  $('body').addClass('page-load');  
  $(window).trigger('scroll');
 }, 100 );
  


if ($(window).width() < 1023) {

$('#FacetFiltersFormMobile summary').unbind('click').click(function() {
  if(!$(this).hasClass('active')){
    $(this).addClass('active');
    $(this).next('div').slideDown();
  }else{
    $(this).removeClass('active');
    $(this).next('div').slideUp();
  }
});
}


   var canBeLoaded = true;
   
$('#load_more_hv').on('click',  function() {
  pag_url = $('#pag-n').attr('data-p-url');
  if (pag_url){

    $.ajax({
        type: 'GET',
        url: pag_url,
        dataType: "html",
    beforeSend: function( xhr ){

          canBeLoaded = false;
          $('#pag-n').remove();
              
    },
    success:function(response) {
      if(response ) {
        result = $(response).find('.hg-product-grid');
        $('.hg-products').append( result );
        canBeLoaded = true; 


          $('.hg-ll-img-st').each(function() {
            if ($(window).width() > 1040 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-m-i');
            }
            if ($(this).is('[style="background-image"]')){ }else {
            $(this).css('background-image','url('+$lod_i+')');
            }
          });
          $('.hg-ll-img-st-sl').each(function() {
            if ($(window).width() > 1040 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-p-i');
            }
            if ($(this).attr('data-flickity-bg-lazyload') == ''){ 
            $(this).attr('data-flickity-bg-lazyload',$lod_i);
            }
          });

      var doAnimations = function() {
      var offset = $(window).scrollTop() + $(window).height(),
          $animatables = $('.animatable');
      if ($animatables.length == 0) {
        $(window).off('scroll', doAnimations);
      }
      
      $animatables.each(function(i) {
         var $animatable = $(this);
           if ($(window).width() < 960) {
            var $scrollstep = 150;
           }else{
            var $scrollstep = 200;
           };
        if (($animatable.offset().top  + $scrollstep) < offset) {
          $animatable.removeClass('animatable').addClass('animated');
        }
      });
    };
    $(window).on('scroll', doAnimations);
$('.prods-sl-n').flickity({ 
      cellAlign: 'left',
      pageDots : false,
      bgLazyLoad: 1,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      lazyLoad: true,
    });
$('.prods-sl-n').flickity().on( 'change.flickity', function( event, index ) {
      $slide_p = index + 1;
      $(this).parents('.has-nav').find('.cur-c').html( $slide_p );
    $('.hg-slide:nth-child('+$slide_p+')').find('.hg-video').trigger('play');
    $('.hg-slide:nth-child('+$slide_p+')').nextAll().find('.hg-video').trigger('pause');
      $('.hg-slide:nth-child('+$slide_p+')').prevAll().find('.hg-video').trigger('pause');
 });

      }
    },    
    error: function() {
   
    }
    });
}else{
canBeLoaded = false;
}
});

  $(window).scroll(function(){
    $scroll = $(window).scrollTop();
    if($(window).width() > 1023){
        $wh = $(window).height() * 2;
    }else{
      $wh = $(window).height() * 3;
    }
      $lb = $('#load_more_hv').offset().top;

      
pag_url_m = Number($('#pag-n').attr('data-mp'));
if (pag_url_m  < 2){
  $('#load_more_hv').hide();
}


if ($scroll + $wh >  $lb &&  canBeLoaded == true ) { 
  $('#load_more_hv').trigger('click');

}
  });

          $('.hg-ll-img-st').each(function() {
            if ($(window).width() > 1040 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-m-i');
            }
            if ($(this).is('[style="background-image"]')){ }else {
            $(this).css('background-image','url('+$lod_i+')');
            }
          });
          $('.hg-ll-img-st-sl').each(function() {
            if ($(window).width() > 1040 ) {
              $lod_i = $(this).attr('data-p-i');
            }else{
              $lod_i = $(this).attr('data-p-i');
            }
            if ($(this).attr('data-flickity-bg-lazyload') == ''){ 
            $(this).attr('data-flickity-bg-lazyload',$lod_i);
            }
          });

  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    location.reload();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }






  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);









